import { render, staticRenderFns } from "./WsDemoExamsSearchExperts.vue?vue&type=template&id=7bb70883"
import script from "./WsDemoExamsSearchExperts.vue?vue&type=script&lang=js"
export * from "./WsDemoExamsSearchExperts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports